<template>
    <div class="talent">
      <Search title="特质基因" :attent="num + '项需关注'" :total="'共计评价' + total + '种特质'" :child="child" backurl="/home">
        <div class="box">
          <van-tabs v-model="activeTab"  @click="tabOnClick">
            <van-tab title="需关注项目">
              <div v-if="data.length === 0 && !loading"  class="noCarry">
                <img src="../../assets/images/nothing3.png" alt="未携带">
              </div>

              <div v-else class="words-cloud">
                <div v-if="gdb3">
                  <span :style="getFontStyle()" v-for="(item, index) in data" :key="index" @click="$router.push('/talentInfo/' + item.id)">{{ item.name }}</span>
                </div>
                <div v-if="gdb2">
                  <span :style="getFontStyle()" v-for="(item, index) in data" :key="index" @click="$router.push('/talentInfo/' + item.itemid)">{{ item.chname }}</span>
                </div>
              </div>
            </van-tab>
            <van-tab title="按分类浏览">
              <Grids :gridsType="talentSystems" systems="talentType"></Grids>
            </van-tab>
          </van-tabs>
        </div>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
import Grids from '@/components/Grids'
export default {
  name: 'index',
  data () {
    return {
     sample_type: this.util.getLS(this.api.sample_type),
      gdb3: false,
      gdb2: false,
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      num: '',
      total: '',
      activeTab: parseInt(this.$route.query.activeTab),
      data: [],
      talentSystems: [],
      sum: 0,
      follow: 0,
      loading: true
    }
  },
  methods: {
    // 数量接口
    getQuantity () {
      this.util.get(this.api.talent_quantity, '', (success) => {
        this.num = success.num
        this.total = success.total
      })
    },
    tabOnClick (index) {
      this.$router.push({path: '/talent?num=' + this.num + '&total=' + this.total + '&activeTab=' + index})
    },
    getFontStyle () {
      let colorNum = [
        parseInt(Math.random() * 255),
        parseInt(Math.random() * 255),
        parseInt(Math.random() * 255)
      ]
      let color = 'rgb(' + colorNum.join(',') + ')'
      let fontSize = (Math.random() * 16 + 12) + 'px'
      return 'color: ' + color + ';font-size:' + fontSize
    },
    getTalentAttentionTalents () {
      this.util.get(this.api.talent_attention_talents, '', (success) => {
        this.data = success.items
        this.loading = false
        this.util.setLS('paginationData', success.items)
      })
    },
    getTalentSystems () {
      this.util.get(this.api.talent_systems, '', (success) => {
        if( this.sample_type === 'childwes_zy'){
            this.talentSystems = [
                { icon: 'iconyinshipx', title: '营养饮食', num: success.items.营养饮食, id: '营养饮食' },
                { icon: 'iconshuiguo1', title: '思维倾向', num: success.items.思维倾向, id: '思维倾向' },
                { icon: 'iconiconfontyundonghuwai01', title: '运动能力', num: success.items.运动能力, id: '运动能力' },
                { icon: 'iconicon084', title: '性格特征', num: success.items.性格特征, id: '性格特征' },
                { icon: 'iconwaimao', title: '体质外貌', num: success.items.体质外貌, id: '体质外貌' },
                { icon: 'iconiosbodyoutline1', title: '毒素代谢', num: success.items.毒素代谢, id: '毒素代谢' }
            ]
        }else{
            this.talentSystems = [
                { icon: 'iconyinshipx', title: '饮食', num: success.items.饮食, id: '饮食' },
                { icon: 'iconshuiguo1', title: '营养', num: success.items.营养, id: '营养' },
                { icon: 'iconiconfontyundonghuwai01', title: '运动', num: success.items.运动, id: '运动' },
                { icon: 'iconicon084', title: '性格', num: success.items.性格, id: '性格' },
                { icon: 'iconwaimao', title: '外貌', num: success.items.外貌, id: '外貌' },
                { icon: 'iconiosbodyoutline1', title: '体质', num: success.items.体质, id: '体质' }
            ]
        }
      
      })
    },
    // gdb2
    getTalentIndex () {
      this.util.get1(this.api.talentIndex, '', (success) => {
        this.data = success.overview
        this.num = success.follow
        this.total = success.sum
        this.loading = false
      })
    },
    getTalentSystems1 () {
      this.talentSystems = [
        { icon: 'iconyinshipx', title: '饮食', id: '饮食' },
        { icon: 'iconshuiguo1', title: '营养', id: '营养' },
        { icon: 'iconiconfontyundonghuwai01', title: '运动', id: '运动' },
        { icon: 'iconicon084', title: '性格', id: '性格' },
        { icon: 'iconwaimao', title: '外貌', id: '外貌' },
        { icon: 'iconiosbodyoutline1', title: '体质', id: '体质' }
      ]
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getQuantity()
      this.getTalentAttentionTalents()
      this.getTalentSystems()
    } else {
      this.gdb2 = true
      this.getTalentIndex()
      this.getTalentSystems1()
    }
  },
  watch: {
    '$route' (to) {
      this.activeTab = parseInt(to.query.activeTab)
    }
  },
  components: {
    Search,
    Grids
  },
  beforeRouteUpdate (to, from, next) {
    this.activeTab = parseInt(to.params.tabid)
    next()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";

  .talent {
    height: 100%;
    background-color: #fff;

    .words-cloud {
      padding: pxToRem(20px) pxToRem(30px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/talent/index.vue